import AxiosInstance from "./Axios";
import Cookies from "universal-cookie";

// GET /tree-reports/trees
//
// Returns every tree the logged-in user participates in (as broker owner,
// sub-owner, IB, or Master IB), one row per tree, e.g.:
// {
//   "status": "Success",
//   "data": {
//     "email": "hcarreno@tvmarkets.com",
//     "trees": [
//       { "id": 1015, "description": "Tree", "is_master": true, ... },
//       { "id": 1000, "description": "BestCapital-001", "is_master": false, ... }
//     ]
//   }
// }
//
// `is_master` tells whether the current user is the Master IB of that
// specific tree. This is the only place this information is available -
// it does NOT come from the login response/"type" cookie.
const TreeReportsRequest = async () => {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");

    const res = await AxiosInstance.get("/tree-reports/trees", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return res;
  } catch (error) {
    console.error("error in request:", error);
    throw error;
  }
};

export default TreeReportsRequest;